export const steps = [
    {
        title: 'Paso 1',
        description: 'Escoga el tipo de operación que desea realizar',
    },
    {
        title: 'Paso 2',
        description: 'Escoga Órden',
    },
    {
        title: 'Paso 3',
        description: 'Escoga Ubicación para operación',
    },

]